import axios from 'axios';
import api from './api';

const callaxios = axios.create({
  // baseURL: 'http://3.228.238.128:9006',
  baseURL: api.baseUrl06,
  headers: {
    'content-type': 'application/json',
    // 'Access-Control-Allow-Origin': 'http://3.228.238.128:9006',
    // 'Access-Control-Allow-Origin': api.baseUrl06,
    // 'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
    // 'Access-Control-Allow-Headers':
    //   'Content-Type, X-Auth-Token, Origin, Authorization, UserId'
  }
})

// configure headers
callaxios.interceptors.request.use(
  config => {
    if (sessionStorage.getItem('LOGGEDIN')) {
      config.headers['Authorization'] =
        'Basic ' +
        'RFRjclRpdEFQRjI5NS1EOTNOLTRSMkQtOEtGLUItVUFUOk0yM0BQZzU3bXUhM2Q='
      config.headers['UserId'] = sessionStorage.getItem('USERID')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default callaxios
